export default {
      id: "speed-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#speed",
      toString: function () {
        return this.url;
      }
    }